export const environment = {
  production: true,
  localShipAndShorex: false,
  localMarketingBox: false,
  showLoaderQueueInConsole: true,
};
